import { Refinement } from "@siteimprove/alfa-refinement";
const { isObject } = Refinement;
/**
 * @public
 */
export var Body;
(function (Body) {
    function isBody(value) {
        return isObject(value) && value.body instanceof ArrayBuffer;
    }
    Body.isBody = isBody;
})(Body || (Body = {}));
//# sourceMappingURL=body.js.map